import { Helmet } from "react-helmet-async";
import { useBrand } from "../contexts/BrandContext";

/**
 * Reusable SEO helper that composes page titles based on active brand context.
 *
 * Usage:
 *   <SEO title="Ürünler" suffix /> // "Ürünler | Astrhori"
 *   <SEO title="Astrhori 50mm" override /> // exact title
 *   <SEO title="Astrhori 50mm" suffixWith="Astrhori" /> // "Astrhori 50mm | Astrhori"
 *   <SEO admin title="Brands" /> // "Brands | Noon Foto Admin"
 *   <SEO home /> // "Astrhori - Türkiye Resmi Distribütörü" or "Noon Foto - Türkiye Resmi Distribütörü"
 */
export default function SEO({ title, suffix = true, suffixWith, override, admin, home, description }) {
  const { mode, brand } = useBrand();
  const brandName = mode === "brand" && brand ? brand.name : "Noon Foto";

  let finalTitle = title || "";

  if (admin) {
    finalTitle = `${title || "Admin"} | Noon Foto Admin`;
  } else if (home) {
    finalTitle = `${brandName} - Türkiye Resmi Distribütörü`;
  } else if (override) {
    finalTitle = title;
  } else if (suffixWith) {
    finalTitle = `${title} | ${suffixWith}`;
  } else if (suffix && title) {
    finalTitle = `${title} | ${brandName}`;
  } else if (title) {
    finalTitle = title;
  } else {
    finalTitle = brandName;
  }

  return (
    <Helmet>
      <title>{finalTitle}</title>
      {description && <meta name="description" content={description} />}
    </Helmet>
  );
}
